/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Sort_ByInputs */

const en_view_sort_by = /** @type {(inputs: View_Sort_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by`)
};

const de_view_sort_by = /** @type {(inputs: View_Sort_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {View_Sort_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const view_sort_by = /** @type {((inputs?: View_Sort_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Sort_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_view_sort_by(inputs)
	return en_view_sort_by(inputs)
});